import { useEffect, useState } from "react";

type ReturnType = [boolean, (locked: boolean) => void];

function useScrollBlock(initialLocked = false): ReturnType {
	const [locked, setLocked] = useState(initialLocked);

	// Do the side effect before render
	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
		if (!locked) {
			return;
		}

		// Save initial body style
		const originalOverflow = document.body.style.overflow;
		const originalPaddingRight = document.body.style.paddingRight;

		// Lock body scroll
		// document.body.style.overflow = "hidden";

		// Get the scrollBar width
		const root = document.querySelector<HTMLDivElement>("#root"); // or root
		const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;

		// Avoid width reflow
		if (scrollBarWidth) {
			document.body.style.paddingRight = `${scrollBarWidth}px`;
		}

		return () => {
			document.body.style.overflow = originalOverflow;

			if (scrollBarWidth) {
				document.body.style.paddingRight = originalPaddingRight;
			}
		};
	}, [locked]);

	return [locked, setLocked];
}

export default useScrollBlock;
